import { createContext } from 'react';

import { ExtensionData } from '../../types/extensionData';

export const ExtensionDataContext = createContext<ExtensionData>({
  extensionId: '',
} as ExtensionData);
